import React from "react";

const NotesModal = ({
  modalIsOpen,
  senderNotes,
  setSenderNotes,
  handlerOpenNotesClosed,
  handleToContinue,
  selectedLanguage,
}) => {
  if (!modalIsOpen) return null;

  return (
    <div
      className="modal"
      id="myModal1"
      style={{ display: "block", backgroundColor: "#8080801c" }}>
      <div className="modal-dialog modal-dialog-centered modal-customelg">
        <div className="modal-content">
          <div className="modal-header pb-1">
            <h4
              className="d-flex align-items-center text-danger fw-bold "
              htmlFor="">
              {selectedLanguage.LstLanguageCodes.UI_Note}
            </h4>
            <button
              type="button"
              className="btn btn-outline-danger modalclose download"
              onClick={(e) => handlerOpenNotesClosed()}>
              <span className="material-icons font-20">
                highlight_off
              </span>
            </button>
          </div>
          <div className="modal-body  justify-content-center d-flex">
            <textarea
              className="textareaPadding  w-100 custom-inputBorder"
              draggable="false"
              name="ReaderNotes"
              placeholder="Optional"
              rows="5"
              cols="58"
              maxLength="255"
              value={senderNotes}
              onChange={(e) => setSenderNotes(e.target.value)}></textarea>
          </div>
          <div className="mb-2 justify-content-center d-flex">
            <button
              type="button"
              className="btn btn-secondary py-2 approve"
              data-bs-dismiss="modal"
              onClick={handleToContinue}>
              {selectedLanguage.LstLanguageCodes.UI_Continue}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotesModal;
